<template>
  <!-- The one content width for every page; shrinks to fit on narrower screens. -->
  <div class="mx-auto flex w-full max-w-220 flex-col gap-6">
    <slot />
  </div>
</template>
